import styled, { css } from 'styled-components';
import { mediaMixin, spaceMixin } from '@zillow/constellation';

export const StyledAddressDetails = styled.div`
  overflow: hidden;

  ${mediaMixin(
    'md',
    css`
      margin-right: ${spaceMixin('xs')};
    `,
  )}

  ${mediaMixin(
    'lg',
    css`
      margin-right: ${spaceMixin('sm')};
    `,
  )}
`;
